import React from 'react';

// WhatsApp clinic number — update this to match your actual number (with country code, no +)
const WA_NUMBER = '919606209376'; // ← Replace with real WhatsApp number

const WA_ICON = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

function waLink(packageName) {
  const text = encodeURIComponent(`Hi KayaSparsha! I'm interested in the *${packageName}* package. Please share more details.`);
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

const PACKAGES = [
  {
    icon: '🧘', name: 'Stress Relief Package', duration: 'Multi-session', featured: false,
    note: 'For burnout, anxiety & sleep concerns',
    includes: [
      'Doctor consultation',
      '3 Abhyanga + Steam sessions',
      '2 Shirodhara sessions',
      '1 Nasya session'
    ]
  },
  {
    icon: '🦴', name: 'Back Pain Package', duration: '5 Sessions', featured: false,
    note: 'For chronic back & spine discomfort',
    includes: [
      'Kati Basti (5 sessions)',
      'Abhyanga + Steam (5 sessions)'
    ]
  },
  {
    icon: '⚖️', name: 'Weight Loss Package', duration: 'Multi-session', featured: true,
    note: 'Guided fat-loss & metabolism reset',
    includes: [
      'Udwartana (3 sessions)',
      'Virechana',
      'Steam therapy',
      'Diet consultation'
    ]
  },
  {
    icon: '🤱', name: "Women's Wellness Package", duration: 'Multi-session', featured: false,
    note: 'Hormonal balance & holistic care for women',
    includes: [
      'Abhyanga',
      'Virechana',
      'Uttara Basti (where applicable)',
      'Diet & lifestyle counselling'
    ]
  },
  {
    icon: '🔥', name: '7-Day Panchakarma Detox', duration: '7 Days', featured: true,
    note: 'Launch Offer — our signature detox programme',
    includes: [
      'Doctor consultation',
      'Abhyanga + Steam (5 sittings)',
      'Mild Virechana',
      'Personalised diet chart',
      'Follow-up consultation'
    ]
  },
  {
    icon: '🤰', name: 'Garbha Samskara Package', duration: '9 Months', featured: false,
    note: 'Antenatal care, the traditional Ayurvedic way',
    includes: [
      'Doctor consultation & trimester-wise care plan',
      'Personalised Abhyanga & wellness routines',
      'Diet & lifestyle guidance for each trimester',
      'Herbal supplementation as advised by the doctor',
      'Regular follow-up consultations through pregnancy'
    ]
  }
];

export default function Packages() {
  return (
    <section className="packages" id="packages" style={{ paddingTop: 72 }}>
      <div className="container">
        <div className="fade-up" style={{ textAlign: 'center', maxWidth: 620, margin: '0 auto' }}>
          <p className="section-label" style={{ justifyContent: 'center' }}>Curated Programmes</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>
            Wellness <em>Packages</em>
          </h2>
          <p className="section-body" style={{ maxWidth: '100%', textAlign: 'center' }}>
            Our packages ensure complete, committed healing — including consultations,
            therapy sessions, medicines, and take-home prescriptions.
            Pricing is customised for each patient. Enquire on WhatsApp for a personalised quote.
          </p>
        </div>

        <div className="packages-grid">
          {PACKAGES.map((p) => (
            <div key={p.name} className={`pkg-card fade-up ${p.featured ? 'featured' : ''}`}>
              {p.featured && <div className="pkg-badge">Most Popular</div>}
              <div className="pkg-icon">{p.icon}</div>
              <h3 className="pkg-name">{p.name}</h3>
              <div className="pkg-duration">{p.duration}</div>
              <p className="pkg-price-note" style={{ marginTop: 8 }}>{p.note}</p>
              <ul className="pkg-includes">
                {p.includes.map((li, i) => <li key={i}>{li}</li>)}
              </ul>
              <a
                href={waLink(p.name)}
                target="_blank"
                rel="noopener noreferrer"
                className="pkg-btn"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, textDecoration: 'none' }}
              >
                {WA_ICON}
                Enquire on WhatsApp
              </a>
            </div>
          ))}
        </div>

        {/* Monthly subscription banner */}
        <div className="fade-up" style={{ marginTop: 40, padding: 32, background: 'var(--forest)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24 }}>
          <div>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, color: '#f0ebe0' }}>
              Monthly Wellness Subscription
            </p>
            <p style={{ color: 'rgba(240,235,224,0.7)', fontSize: 14, marginTop: 6 }}>
              4 sessions/month — Weekly Abhyanga or Shirodhara for ongoing balance
            </p>
          </div>
          <div>
            <a
              href={waLink('Monthly Wellness Subscription')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ fontSize: 13, padding: '12px 28px', display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}
            >
              {WA_ICON}
              Enquire on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
